import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationModalComponent } from './pagination-modal.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports:[
    // PaginationModalComponent
  ],
  declarations: [
    // PaginationModalComponent
  ]
})
export class PaginationModalModule{}
